export default __webpack_public_path__ + "static/media/cargo_flight.23424275.svg";